/* eslint-disable max-lines */
// tslint:disable: max-file-line-count
import { IJsonQuery } from '../../../types/jsonQuery';

import { FDealType, FOfferType, isAvailable, isAvailableStrict } from '../../../../../JsonQuery';
import { TFilter } from '../../../types/advancedFilters';

interface IFilterList {
  availability(jsonQuery: IJsonQuery): boolean;
  list: TFilter[];
}

const FILTERS_LIST: IFilterList[] = [
  {
    availability: isAvailableStrict(FDealType.Sale, FOfferType.FlatNew),
    list: [
      'withNeighbors',
      'completionYear',
      'undergroundTime',
      'offerType',
      'squareMeterArea',
      'layout',
      // Видео
      // Наличие фото
      // Тип объявления
      'ceilingHeight',
      'floor',
      'floors',
      'constructionType',
      'finishing',
      'saleType',
      'apartments',
      'publicationDate',
      'containWords',
      'excludeWords',
      'contact',
      'offerId',
    ],
  },
  {
    availability: isAvailable(FDealType.Sale, FOfferType.Flat),
    list: [
      'withNeighbors',
      'dealType',
      'undergroundTime',
      'squareMeterArea',
      'layout',
      'ceilingHeight',
      'urbanBathroom',
      'balcony',
      'repair',
      'floor',
      'floors',
      'windows',
      'constructionYear',
      'constructionType',
      // Серия дома
      'demolition',
      'elevators',
      // Пандус
      'parking',
      'saleType',
      'apartments',
      'publicationDate',
      'containWords',
      'excludeWords',
      'contact',
      'offerId',
    ],
  },
  {
    availability: isAvailable(FDealType.Sale, FOfferType.Room),
    list: [
      'withNeighbors',
      'dealType',
      'undergroundTime',
      'squareMeterArea',
      'flatRooms',
      'roomsInDeal',
      'layout',
      'ceilingHeight',
      'urbanBathroom',
      'balcony',
      'repair',
      'floor',
      'floors',
      'windows',
      'constructionYear',
      'constructionType',
      'demolition',
      'elevators',
      'parking',
      'saleType',
      'publicationDate',
      'containWords',
      'excludeWords',
      'contact',
      'offerId',
    ],
  },
  {
    availability: isAvailable(FDealType.Sale, FOfferType.FlatShared),
    list: [
      'withNeighbors',
      'dealType',
      'undergroundTime',
      'squareMeterArea',
      'flatRooms',
      'layout',
      'ceilingHeight',
      'urbanBathroom',
      'balcony',
      'repair',
      'floor',
      'floors',
      'windows',
      'constructionYear',
      'constructionType',
      'demolition',
      'elevators',
      'parking',
      'saleType',
      'apartments',
      'publicationDate',
      'containWords',
      'excludeWords',
      'contact',
      'offerId',
    ],
  },
  {
    availability: isAvailable(FDealType.Sale, FOfferType.House | FOfferType.HousePart | FOfferType.Townhouse),
    list: [
      'withNeighbors',
      'dealType',
      'fromMKAD',
      'undergroundTime',
      'suburbanArea',
      'constructionType',
      'heatingType',
      'suburbanUtilities',
      'suburbanFacilities',
      'landStatus',
      'floors',
      'suburbanBathroom',
      'constructionYear',
      'publicationDate',
      'containWords',
      'excludeWords',
      'contact',
      'offerId',
    ],
  },
  {
    availability: isAvailable(FDealType.Sale, FOfferType.Land),
    list: [
      'withNeighbors',
      'dealType',
      'fromMKAD',
      'undergroundTime',
      'suburbanArea',
      'suburbanUtilities',
      'landStatus',
      'publicationDate',
      'containWords',
      'excludeWords',
      'contact',
      'offerId',
    ],
  },
  {
    availability: isAvailable(FDealType.RentLongterm, FOfferType.Flat),
    list: [
      'withNeighbors',
      'dealType',
      'rentalPeriod',
      'undergroundTime',
      'facilities',
      'livingConditions',
      'squareMeterArea',
      'layout',
      'apartments',
      'ceilingHeight',
      'urbanBathroom',
      'balcony',
      'bathType',
      'repair',
      'windows',
      'floor',
      'floors',
      'constructionYear',
      'constructionType',
      'demolition',
      'elevators',
      // Пандус
      'parking',
      'rentTerms',
      'publicationDate',
      'containWords',
      'excludeWords',
      'contact',
      'offerId',
    ],
  },
  {
    availability: isAvailable(FDealType.RentLongterm, FOfferType.Room),
    list: [
      'withNeighbors',
      'dealType',
      'rentalPeriod',
      'undergroundTime',
      'facilities',
      'livingConditions',
      'squareMeterArea',
      'flatRooms',
      'roomsInDeal',
      'layout',
      'ceilingHeight',
      'urbanBathroom',
      'balcony',
      'bathType',
      'repair',
      'floor',
      'floors',
      'windows',
      'constructionYear',
      'constructionType',
      'demolition',
      'elevators',
      // Пандус
      'parking',
      // Состав съемщиков
      'rentTerms',
      'publicationDate',
      'containWords',
      'excludeWords',
      'contact',
      'offerId',
    ],
  },
  {
    availability: isAvailable(FDealType.RentLongterm, FOfferType.Bed),
    list: [
      'withNeighbors',
      'dealType',
      'rentalPeriod',
      'undergroundTime',
      'facilities',
      'livingConditions',
      'squareMeterArea',
      'flatRooms',
      'roomsInDeal',
      'layout',
      'ceilingHeight',
      'urbanBathroom',
      'balcony',
      'bathType',
      'repair',
      'floor',
      'floors',
      'windows',
      'constructionYear',
      'constructionType',
      'elevators',
      // Пандус
      'parking',
      // Состав съемщиков
      'rentTerms',
      'publicationDate',
      'containWords',
      'excludeWords',
      'contact',
      'offerId',
    ],
  },
  {
    availability: isAvailable(FDealType.RentLongterm, FOfferType.House | FOfferType.HousePart | FOfferType.Townhouse),
    list: [
      'withNeighbors',
      'dealType',
      'rentalPeriod',
      'fromMKAD',
      'undergroundTime',
      'suburbanArea',
      'facilities',
      'suburbanFacilities',
      'bathType',
      'suburbanBathroom',
      'repair',
      'floors',
      'constructionType',
      'heatingType',
      'constructionYear',
      'rentTerms',
      'livingConditions',
      'publicationDate',
      'containWords',
      'excludeWords',
      'contact',
      'offerId',
    ],
  },
  {
    availability: isAvailable(FDealType.RentDaily, FOfferType.Flat),
    list: [
      'withNeighbors',
      'dealType',
      'undergroundTime',
      'facilities',
      'livingConditions',
      'squareMeterArea',
      'apartments',
      'ceilingHeight',
      'urbanBathroom',
      'balcony',
      'bathType',
      'repair',
      'floor',
      'floors',
      'windows',
      'constructionYear',
      'constructionType',
      'elevators',
      // Пандус
      'parking',
      'publicationDate',
      'containWords',
      'excludeWords',
      'contact',
      'offerId',
    ],
  },
  {
    availability: isAvailable(FDealType.RentDaily, FOfferType.Room | FOfferType.Bed),
    list: [
      'withNeighbors',
      'dealType',
      'undergroundTime',
      'facilities',
      'livingConditions',
      'squareMeterArea',
      'flatRooms',
      'roomsInDeal',
      'ceilingHeight',
      'urbanBathroom',
      'balcony',
      'bathType',
      'repair',
      'floor',
      'floors',
      'windows',
      'constructionYear',
      'constructionType',
      'elevators',
      // Пандус
      'parking',
      // Состав съемщиков
      'publicationDate',
      'containWords',
      'excludeWords',
      'contact',
      'offerId',
    ],
  },
  {
    availability: isAvailable(FDealType.RentDaily, FOfferType.House),
    list: [
      'withNeighbors',
      'dealType',
      'fromMKAD',
      'undergroundTime',
      'suburbanArea',
      'facilities',
      'livingConditions',
      'suburbanFacilities',
      'bathType',
      'suburbanBathroom',
      'repair',
      'floors',
      'constructionType',
      'heatingType',
      'constructionYear',
      'publicationDate',
      'containWords',
      'excludeWords',
      'contact',
      'offerId',
    ],
  },
  {
    availability: isAvailable(FDealType.Any, FOfferType.Any),
    list: ['withNeighbors', 'publicationDate', 'containWords', 'excludeWords', 'contact', 'offerId'],
  },
];

export function getAvailableFilters(jsonQuery: IJsonQuery): TFilter[] {
  const type = FILTERS_LIST.find(f => f.availability(jsonQuery));

  return (type && type.list) || [];
}
